export const state = {
  activeMenuId: '',
  activeSubmenuId: '',
  menuElements: []
};

export const mutations = {
  setActiveMenuId(state, payload) {
    state.activeMenuId = payload;
  },
  setActiveSubmenuId(state, payload) {
    state.activeSubmenuId = payload;
  },
  addMenuElementToList(state, payload) {
    state.menuElements = [].concat(...state.menuElements, [payload]);
  },
};

export const actions = {
  setActiveMenuId({ commit }, payload) {
    commit('setActiveMenuId', payload);
  },
  setActiveSubmenuId({ commit }, payload) {
    commit('setActiveSubmenuId', payload);
  },
  addMenuElementToList({ commit }, payload) {
    commit('addMenuElementToList', payload);
  }
};
export const getters = {
  activeMenuId: (state) => state.activeMenuId,
  menuElements: (state) => state.menuElements,
  activeSubmenuId: (state) => state.activeSubmenuId,
};

export default  {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
